export const Role = {
    IPSAdmin: 'IPS Administrator',
    Admin: 'Administrator',
    Publisher: 'Publisher',
    Author: 'Author',
    User: 'User',
    DisableAdminRoles: ['Publisher', 'Author', 'User'],
    PublishRoles: ['Publisher', 'Administrator', 'IPS Administrator'],
};
